module.exports = __webpack_public_path__ + "static/media/031-pakistan.9b0ab885.svg";